import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // isAuthenticated: localStorage.getItem("isAuth") || false,
    // role: localStorage.getItem("role") || null,
    // password: "admin",
    user:  JSON.parse(localStorage.getItem("user")) || {},
    token: localStorage.getItem("token") || "",
};

const authSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        // setLogin: {
        //     prepare(userName, password) {
        //         const payload = { userName, password };
        //         return { payload: payload }
        //     },
        //     reducer: (state, action) => {
        //         const { userName, password } = action.payload;
        //         const isAuth = ("admin" === userName && "admin" === password) || ("manager" === userName && "manager" === password) || ("user" === userName && "user" === password);
        //         if(isAuth){
        //             state.role = userName;
        //         }else{
        //             state.role = null;
        //         }
        //         state.isAuthenticated = isAuth;
        //         localStorage.setItem("isAuth", isAuth);
        //         localStorage.setItem("role", state.role);
        //     }
        // },
        setLogin: (state, action) => {
            const { token, user } = action.payload;
            state.token = token;
            state.user = user;
            // console.log(token, user);
            // const isAuth = ("admin" === userName && "admin" === password) || ("manager" === userName && "manager" === password) || ("user" === userName && "user" === password);
            // if (isAuth) {
            //     state.role = userName;
            // } else {
            //     state.role = null;
            // }
            // state.isAuthenticated = isAuth;
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));
            // localStorage.setItem("role", state.role);

        },
        setLogout: (state) => {
            // state.isAuthenticated = false;
            // Clear localStorage on logout
            state = initialState;
            localStorage.removeItem("token");
            localStorage.removeItem("user");
        }

    }
});

export const {
    setLogin,
    setLogout,
} = authSlice.actions;

export default authSlice.reducer;